export const SET_ERRORS = 'PAPERS_SET_ERRORS';

export function setErrors(errors, elementId) {
    return {
        type: SET_ERRORS,
        elementId,
        errors,
    };
};
